// extracted by mini-css-extract-plugin
export default {"for-phone-bank":"app-Imports-ImportsUpload-module__zObQDR1a0nm_iyRXNdtN","container":"app-Imports-ImportsUpload-module__MQD0keVZ2_4QroBebS5Q"};